import React, { useContext, useState, Fragment } from "react";
import { AlignCenter } from "react-feather";
import { Link } from "react-router-dom";
import { Image } from "../../AbstractElements";
import CheckContext from "../../_helper/Customizer";
import { Icon } from "@progress/kendo-react-common";

const Leftbar = () => {
  const { toggleIcon,mixLayout, toggleSidebar } = useContext(CheckContext);
  const [toggle, setToggle] = useState(true);

  const openCloseSidebar = () => {
    setToggle((prevState) => !prevState);
    toggleSidebar(!toggleIcon);
  };
  return (
    <Fragment>
      <div className="main-header-left">
        {mixLayout ? (
          <div className="logo-wrapper">
            <Link to={``}>
              <Image
                attrImage={{
                  className: "img-fluid d-inline",
                  src: `${require("../../assets/images/logo/logo.png")}`,
                  alt: "",
                }}
              />
            </Link>
          </div>
        ) : (
          <div className="dark-logo-wrapper">
            <Link to={``}>
              <Image
                attrImage={{
                  className: "img-fluid d-inline",
                  src: `${require("../../assets/images/logo/logo.png")}`,
                  alt: "",
                }}
              />
            </Link>
          </div>
        )}
        <div className="toggle-sidebar" onClick={() => openCloseSidebar()}>
          {/* <AlignCenter className="status_toggle middle" id="sidebar-toggle" /> */}
          <Icon  style={{ fontSize: '25px' }} className="m-r-10" name="align-center" />
        </div>
      </div>
    </Fragment>
  );
};

export default Leftbar;
